/**
 * A one-slot channel carrying the movement stick's position to whatever draws it.
 *
 * This exists so the stick can be drawn *without* React state. A thumb drag produces
 * pointer events at roughly the display refresh rate, and routing those through
 * `setState` would re-render on every one of them, while the 3D scene is trying to hold
 * a frame budget. The subscriber mutates DOM style directly instead.
 */

import type { StickView } from './producers/touch';

let listener: ((stick: StickView) => void) | null = null;

/** Register the drawer. Returns an unsubscribe function. */
export function subscribeStick(next: (stick: StickView) => void): () => void {
  listener = next;
  return () => {
    if (listener === next) listener = null;
  };
}

export function publishStick(stick: StickView): void {
  listener?.(stick);
}
